export { default } from './FirstPersonsCard';
